import { clearPwaCaches } from '@/shared/lib/clearPwaCaches'
import { getUpdateSW } from '@/features/sw/swUpdateStore'

/**
 * Limpa caches, pede ao SW para ativar a nova versão e recarrega (`updateSW(true)`).
 */
export async function applyPwaUpdate(): Promise<void> {
  await clearPwaCaches()
  const fn = getUpdateSW()
  if (fn) {
    try {
      await fn(true)
    } catch {
      window.location.reload()
    }
    return
  }
  window.location.reload()
}
